import React from 'react';
import { Button, Grid } from '@mui/material';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { UnavowedPopup } from '@gamiphy/loyalty-station-desktop/components/popups/unavowed';
import { LevelStore } from '@gamiphy/loyalty-station-desktop/store/level';
import { TierConfigType } from '@gamiphy/bl/level';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const [popupOpen, setPopupOpen] = React.useState(false);
  const onRedeem = React.useCallback(() => {
    if (UserStore.isRealUser) {
      UiStore.setPage(Pages.welcomeGift);
    } else {
      setPopupOpen(true);
    }
  }, [UserStore.isRealUser]);

  const text = React.useMemo(() => {
    switch (WelcomeGiftStore.type) {
      case WelcomeGiftTypes.discount:
        return (
          <Trans
            i18nKey="welcomeGift.discount.welcomeCoupon"
            defaults="Welcome Coupon"
          />
        );
      case WelcomeGiftTypes.points:
        return (
          <Trans
            i18nKey="welcome.points"
            defaults="Welcome {{, gems}}"
            values={{}}
          />
        );
      default:
        return undefined;
    }
  }, [WelcomeGiftStore.type]);

  const reward = React.useMemo(() => {
    switch (WelcomeGiftStore.type) {
      case WelcomeGiftTypes.discount:
        return (
          <Trans
            i18nKey="welcomeGift.cashReward"
            defaults="{{value}}"
            values={{
              value: WelcomeGiftStore.reward,
            }}
          />
        );
      case WelcomeGiftTypes.points:
        return (
          <Trans
            i18nKey="gemsValue"
            defaults="{{gems, gems}}"
            values={{
              gems: WelcomeGiftStore.reward,
            }}
          />
        );
      default:
        return undefined;
    }
  }, [WelcomeGiftStore.type, WelcomeGiftStore.reward]);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={(theme) => ({
            backgroundColor: '#fafafa',
            fontSize: '12px',
            color: theme.palette.text.primary,
            minHeight: '40px',
            borderRadius: '4px',
            paddingInline: theme.spacing(2),
          })}
        >
          <Grid sx={{ color: '#a0a0a0' }}>{text}</Grid>
          <Grid>{reward}</Grid>
        </Grid>
      </Grid>
      {(LevelStore.tierConfig?.type === TierConfigType.exp && WelcomeGiftStore.expReward !== 0) && (
        <Grid size={12}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={(theme) => ({
              backgroundColor: '#fafafa',
              fontSize: '12px',
              color: theme.palette.text.primary,
              minHeight: '40px',
              borderRadius: '4px',
              paddingInline: theme.spacing(2),
            })}
          >
            <Grid sx={{ color: '#a0a0a0' }}>{t('welcomeGift.exp', { defaultValue: '{{, exp}}' })}</Grid>
            <Grid>{t('expValue', { defaultValue: '{{exp, exp}}', exp: WelcomeGiftStore.expReward })}</Grid>
          </Grid>
        </Grid>
      )}
      <Grid size={12}>
        <Button
          variant="contained"
          onClick={onRedeem}
          fullWidth
        >
          <Trans
            i18nKey="shared.next"
            defaults="Next"
          />
        </Button>
      </Grid>
      <UnavowedPopup
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
        title={t('unavowedPopup.rewardTitle', 'Sign up now to redeem your coupon for exclusive discounts!')}
      />
    </Grid>
  );
};

export default Footer;
